import React                                                        from 'react';
import { withStyles }                                               from '@material-ui/core/styles';
import {colores, globales,funciones}                                          from '../../global';
import BarraBotones                                                 from '../../components/Barra_menu';
import AuthService                                                  from '../../AuthService';
import Request                                                      from 'superagent';
import CustomTable                                                  from '../../components/CustomTable';
import {Table}                                                      from '@devexpress/dx-react-grid-material-ui';
import Dialog                                                       from '@material-ui/core/Dialog';
import DialogContent                                                from '@material-ui/core/DialogContent';
import DialogTitle                                                  from '@material-ui/core/DialogTitle';
import CircularProgress                                             from '@material-ui/core/CircularProgress';
import Backdrop                                                     from '@material-ui/core/Backdrop';
import Icono                                                        from '../../components/Icono'
import TableRowsIndexer                                             from '../../components/tableRowsIndexer'
import Checkbox                         from '@material-ui/core/Checkbox';
import Tooltip                                                      from '@material-ui/core/Tooltip';
import { Typography }                   from '@material-ui/core';
import {TableSummaryRow} from '@devexpress/dx-react-grid-material-ui';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import {virtual} from '../../components/VirtualListBox';

let Auth = new AuthService();
var ip=globales.ip
var border_dialog=globales.border_dialog
var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
var movil_pequeño=/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

//let searchWorker = undefined;
let isVisibleRowSelected = false;
const colorRowSelected =  'rgb('+ colores.tabla.selection +')';
let alternateColorRow1 = colores.tabla.alternateColorRow1; 
let alternateColorRow2 = colores.tabla.alternateColorRow2;
const ListboxComponent = virtual.ListboxComponent;

const getRowId = row => row.ID_CURSO_HIJO;
const getRowId_niveles = row => row.ID_CURSO_HIJO;


const defaultHiddenColumnNames= ['ID_SUFICIENCIA','SIMBOLO_MONEDA','ID_CURSO_HIJO','ID_CURSO_PADRE','ID_FACTURA','CURSO_PADRE','ID_DETALLE_PLAN','CHECK1','PAGO','ESPECIAL'];
const defaultHiddenColumnNames_niveles= ['SECUENCIA','SIMBOLO_MONEDA','CODIGO_CURSO','CREDITOS','ID_CURSO_HIJO','ID_CURSO_PADRE','ID_FACTURA','CURSO_PADRE','ID_DETALLE_PLAN','CHECK1','PAGO'];

const columns= [{name:'CHECK',title: ' '},{name:'CODIGO_CURSO',title: 'Código'},{name:'DESCRIPCION_CURSO',title: 'Descripción'}
  ,{name:'CREDITOS',title: 'UV'},{name:'ID_CURSO_HIJO',title: 'ID_CURSO_HIJO'},{name:'ID_CURSO_PADRE',title: 'ID_CURSO_PADRE'},
  {name:'ID_FACTURA',title: 'ID_FACTURA'},
  {name:'CURSO_PADRE',title: 'CURSO_PADRE'},{name:'ID_DETALLE_PLAN',title: 'ID_DETALLE_PLAN'},{name:'ID_SUFICIENCIA',title: 'ID_SUFICIENCIA'},
  {name:'MONTO',title: 'Monto'},{name:'GRUPO',title: 'GRUPO'},{name:'ESTADO',title: 'Estado'},{name:'SIMBOLO_MONEDA',title: 'SIMBOLO_MONEDA'},{name:'CHECK1',title: 'CHECK1'},{name:'PAGO',title: 'PAGO'},{name:'ESPECIAL',title: 'ESPECIAL'},{name:'ELIMINAR',title: ' '},
];

const columns_niveles= [{name:'CHECK',title: ' '},{name:'CODIGO_CURSO',title: 'Código'},{name:'DESCRIPCION_CURSO',title: 'Descripción'}
,{name:'CREDITOS',title: 'UV'},{name:'ID_CURSO_HIJO',title: 'ID_CURSO_HIJO'},{name:'ID_CURSO_PADRE',title: 'ID_CURSO_PADRE'}
,{name:'ID_FACTURA',title: 'ID_FACTURA'}
,{name:'CURSO_PADRE',title: 'CURSO_PADRE'},{name:'ID_DETALLE_PLAN',title: 'ID_DETALLE_PLAN'}
,{name:'MONTO',title: 'Monto'},{name:'ESTADO',title: 'Estado'}
,{name:'SECUENCIA',title: 'SECUENCIA'}
,{name:'CHECK1',title: 'CHECK1'},{name:'SIMBOLO_MONEDA',title: 'SIMBOLO_MONEDA'},{name:'PAGO',title: 'PAGO'},{name:'ELIMINAR',title: ' '}]

const tableColumnExtensions= [
    { columnName: 'CHECK', wordWrapEnabled: false, align: 'center',width: 60},
    { columnName: 'CODIGO_CURSO', wordWrapEnabled: false, align: 'center',width: 250},
    { columnName: 'DESCRIPCION_CURSO', wordWrapEnabled: true, align: 'center'},
    { columnName: 'CREDITOS', wordWrapEnabled: false, align: 'center',width: 50},
    { columnName: 'MONTO', wordWrapEnabled: false, align: 'center',width: 200},
    { columnName: 'ESTADO', wordWrapEnabled: false, align: 'center',width: 150},
    { columnName: 'ELIMINAR', wordWrapEnabled: false, align: 'center',width: 150},
];
const tableColumnExtensions_niveles= [{ columnName: 'CHECK', wordWrapEnabled: false, align: 'center',width: 60},
    { columnName: 'DESCRIPCION_CURSO', wordWrapEnabled: true, align: 'center'},
    { columnName: 'MONTO', wordWrapEnabled: false, align: 'center',width: 120},
    { columnName: 'ESTADO', wordWrapEnabled: false, align: 'center',width: 150},
    { columnName: 'ELIMINAR', wordWrapEnabled: false, align: 'center',width: 150},
];

/*
const totalSummaryItems = [
  { columnName: "CHECK", type: "count" },
  { columnName: "MONTO", type: "sum" },    
];*/

const groupSummaryItems = [ 
  { columnName: "MONTO", type: "sum" },
];

const grouping= [{ columnName: 'GRUPO' }]


const GroupCellContent = ({ column, row }) => {
  return(
  <span>    
     {row.value}
  </span>
  )
};
/*                           CLASES DE ESTILO                       */

var styles = theme =>({
  popper: {
    zIndex: 400500,
  },
    Dialog:{
        borderRadius: border_dialog,
        margin:0,
        padding:0
    },
    backdrop: {
      zIndex: 500000,
      color: '#fff', 
      flexDirection: 'column'
    },
    select: { //CONFIGURA EL SELECT 
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'50%',
      },
      textField: {
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'20%',
        width: '20%'      
      },
    })

/*                                        EXPORT                                      */
export default withStyles(styles)(
    class Suficiencia_estudiante extends React.Component {
      tablaRef = React.createRef();

      constructor(props) {
        super(props);
        this.l= props.l
        this.e= props.e
        this.i= props.i
        this.isVisibleRowSelected=isVisibleRowSelected
        this.actualizarbarra=props.actualizarbarra
        this.actualizarcircular=props.actualizarcircular

        this.state = {
            openBackDrop:      false, 
            open_niveles:       false,
            open_seleccion_niveles: false,
            open_borrar_niveles:  false,
            segundo_grupo: '',
            isLoggin:          undefined,
            heightTableMain:    0,
            rows: [],
            rows_niveles: [],
            expandedGroups: [],
            filteringColumnExtensions: [],
            filters: [],
            expandedRowIds: [],
            enabledFilterRows: true,
            selection: [],
            selection_niveles: [],
            open_seleccion: false,
            open_borrar:    false,
            optionAutocompleteAdd: [],
            isLoadingClientes: true,
            loadingsuficiencias: false,
            openAutoCompleteAdd: false,
            valueAutoCompleteAdd: null,
            isSaving: false,
        }

        
        const trow = TableRow => withStyles(styles, { name: "Row" })( ({classes,highlighted, rowIndex, row, selectByRowClick, ...props}) => {

            const odd = !!(rowIndex % 2);
                    
            if (this.state.selection[0]===undefined?this.state.selection[0]:this.state.selection[0].ID_CURSO_HIJO === props.tableRow.row.ID_CURSO_HIJO) { isVisibleRowSelected = true; }
               return (
                   <Table.Row {...props}
                   style={{
                       //cursor: 'pointer',
                       backgroundColor:  this.state.selection[0]===undefined?odd ? alternateColorRow1 : alternateColorRow2:this.state.selection[0].ID_CURSO_HIJO === props.tableRow.row.ID_CURSO_HIJO ? colorRowSelected : 
                       odd ? alternateColorRow1 : alternateColorRow2,     
                       padding: '0rem 0rem !important',
                       margin: '0px',                 
                     }}
                   />
                 );
        });
        const trow_niveles = TableRow => withStyles(styles, { name: "Row" })( ({classes,highlighted, rowIndex, row, selectByRowClick, ...props}) => {

          const odd = !!(rowIndex % 2);
                  
          if (this.state.selection_niveles[0]===undefined?this.state.selection_niveles[0]:this.state.selection_niveles[0].ID_CURSO_HIJO === props.tableRow.row.ID_CURSO_HIJO) { isVisibleRowSelected = true; }
             return (
                 <Table.Row {...props}
                 style={{
                     //cursor: 'pointer',
                     backgroundColor:  this.state.selection_niveles[0]===undefined?odd ? alternateColorRow1 : alternateColorRow2:this.state.selection_niveles[0].ID_CURSO_HIJO === props.tableRow.row.ID_CURSO_HIJO ? colorRowSelected : 
                     odd ? alternateColorRow1 : alternateColorRow2,     
                     padding: '0rem 0rem !important',
                     margin: '0px',                 
                   }}
                 />
               );
      });


      const VirtualTable_cellComponent_niveles = (props) => {
        const { column }    = props;
        const {row}         = props;

        const ClickCheckbox=(ID_CURSO_HIJO,ID_CURSO_PADRE,DESCRIPCION_CURSO,MONTO,ID_FACTURA,ID_DETALLE_PLAN,TIPO) => event =>{
          this.setState({selection_niveles: [{ID_CURSO_HIJO,ID_CURSO_PADRE,DESCRIPCION_CURSO,MONTO,ID_FACTURA,ID_DETALLE_PLAN}] ,open_seleccion_niveles: TIPO===1?true:false,open_borrar_niveles: TIPO===2?true:false})
        }

        if(column.name==="ESTADO")
          {
            return(
              <Table.Cell {...props} align='center' style={{padding: 0, height:'8px',}}>
                {row.CHECK1?row.PAGO?<b style={{color:'green'}}>Pagada</b>:<b style={{color:'red'}}>Pendiente de Pago</b>:null}
              </Table.Cell>
            );
          }

          if(column.name==="CHECK")
          {
            return(
              <Table.Cell {...props} align='center' style={{padding: 0, height:'8px',}}>
                <Checkbox checked={row.CHECK1} 
                  onClick={ClickCheckbox(row.ID_CURSO_HIJO,row.ID_CURSO_PADRE,row.DESCRIPCION_CURSO,row.MONTO,row.ID_FACTURA,row.ID_DETALLE_PLAN,1)}
                  disabled={row.SECUENCIA===1?row.CHECK1:this.state.rows_niveles[row.SECUENCIA-2]!==undefined?this.state.rows_niveles[row.SECUENCIA-2].CHECK1?row.CHECK1:true:row.CHECK1}
                  style={{padding: 0, height:'10px', margin: 0}}
                />
             </Table.Cell>
            );
          }
          if(column.name==="ELIMINAR")
          {
            return(
            <Table.Cell {...props} align='center' style={{padding: 0, height:'8px',}}>
              {
                row.CHECK1&&!row.PAGO?(this.state.rows_niveles[row.SECUENCIA]!==undefined?this.state.rows_niveles[row.SECUENCIA].CHECK1:false)?
                <Button disabled={true}
                  style={{padding:8, paddingTop:5, paddingBottom:5, textTransform: 'none'}}
                  variant='outlined'
                  color="default"
                  startIcon={<Icono icono={'Delete'} style={{margin:0}}/>}>
                    Eliminar
                </Button>
                :<Tooltip title='Eliminar Factura' > 
                  <Button
                    style={{padding:8,paddingTop:5,paddingBottom:5,textTransform: 'none',color:'red'}}   onClick={ClickCheckbox(row.ID_CURSO_HIJO,row.ID_CURSO_PADRE,row.DESCRIPCION_CURSO,row.MONTO,row.ID_FACTURA,row.ID_DETALLE_PLAN,2)}
                    variant='outlined' 
                    startIcon={<Icono icono={'Delete'} style={{margin:0}}/>}>
                    Eliminar
                  </Button>
               </Tooltip>
               :null
              } 
          </Table.Cell>
          );

          }
          if(column.name==="MONTO")
          {
            return(
              <Table.Cell {...props} align='center' style={{padding: 0, height:'8px',}}>
                  {row.SIMBOLO_MONEDA+' '+ row.MONTO}
              </Table.Cell>
            );
          }

          return(
            <Table.Cell {...props} style={{padding: 0, height:'45px',}}/>
          );
      }

        const VirtualTable_cellComponent = (props) => {
          const { column }    = props;
          const {row}         = props;
          const ClickCheckbox=(ID_CURSO_HIJO,ID_CURSO_PADRE,CODIGO_CURSO,DESCRIPCION_CURSO,MONTO,ID_FACTURA,ID_DETALLE_PLAN,TIPO) => event =>{
            
            this.setState({selection: [{ID_CURSO_HIJO,ID_CURSO_PADRE,CODIGO_CURSO,DESCRIPCION_CURSO,MONTO,ID_FACTURA,ID_DETALLE_PLAN}] ,open_seleccion: TIPO===1?true:false,open_borrar: TIPO===2?true:false})
          }
          const Clickniveles=(ID_CURSO_HIJO,ID_CURSO_PADRE,CODIGO_CURSO,DESCRIPCION_CURSO,MONTO,ID_FACTURA,ID_DETALLE_PLAN,ID_SUFICIENCIA) => event =>{
            this.setState({selection: [{ID_CURSO_HIJO,ID_CURSO_PADRE,CODIGO_CURSO,DESCRIPCION_CURSO,MONTO,ID_FACTURA,ID_DETALLE_PLAN,ID_SUFICIENCIA}],open_niveles:true})
          }

          if(column.name==="ESTADO")
          {
            return(
              <Table.Cell {...props} align='center' style={{padding: 0,}}>
                {row.CHECK1?row.PAGO?<b style={{color:'green'}}>Pagada</b>:<b style={{color:'red'}}>Pendiente de Pago</b>:null}
              </Table.Cell>
            );
          }

          if(column.name==="CHECK")
          {
            return(
              <Table.Cell {...props} align='center' style={{padding: 0,}}>
                <Checkbox checked={row.CHECK1} 
                  onClick={ClickCheckbox(row.ID_CURSO_HIJO,row.ID_CURSO_PADRE,row.CODIGO_CURSO,row.DESCRIPCION_CURSO,row.MONTO,row.ID_FACTURA,row.ID_DETALLE_PLAN,1)}
                  disabled={row.CHECK1}
                 style={{padding: 0, height:'10px', margin: 0}}
             />
             </Table.Cell>
            );
          }
          if(column.name==="MONTO")
          {
            return(
              <Table.Cell {...props} align='center' style={{padding: 0,}}>
                  {row.SIMBOLO_MONEDA+' '+ row.MONTO}
              </Table.Cell>
            );
          }
          if(column.name==="ELIMINAR")
          {
            return(
            <Table.Cell {...props} align='center' style={{padding: 0,}}>
              {row.CHECK1?
              !row.PAGO?
                  <Tooltip title='Eliminar Factura' > 
                  <Button   style={{padding:8,paddingTop:5,paddingBottom:5,textTransform: 'none',color:'red'}}   
                  onClick={ClickCheckbox(row.ID_CURSO_HIJO,row.ID_CURSO_PADRE,row.CODIGO_CURSO,row.DESCRIPCION_CURSO,row.MONTO,row.ID_FACTURA,row.ID_DETALLE_PLAN,2)}
                  variant='outlined' 
                   startIcon={<Icono icono={'Delete'} style={{margin:0}}/>}>
                     Eliminar
                   </Button>
                 </Tooltip>
                :row.ESPECIAL?
                <Tooltip title='Aplica a Otros Niveles' > 
                  <Button   style={{padding:10,paddingTop:5,paddingBottom:5,textTransform: 'none'}}  variant='outlined' color='primary'
                  onClick={Clickniveles(row.ID_CURSO_HIJO,row.ID_CURSO_PADRE,row.CODIGO_CURSO,row.DESCRIPCION_CURSO,row.MONTO,row.ID_FACTURA,row.ID_DETALLE_PLAN,row.ID_SUFICIENCIA)}
                  startIcon={<Icono icono={'Add'}  style={{margin:0}}/>}>
                    Niveles
                  </Button> 
                </Tooltip>:null
                :null
              }     
            </Table.Cell>
            );
          }
          return(
              <Table.Cell {...props} style={{padding: 0,}}/>
            );
      }

      const TotalGroupCellComponent = (props) => {
        var allMONEDAS=[]
                var found = null;
                this.state.rows.forEach(
                  function getCheck(item, index) {
                    if(item.CHECK1){
                        found = allMONEDAS.find(grupo => grupo === item.SIMBOLO_MONEDA);
                        if (found == null){
                          allMONEDAS.push(item.SIMBOLO_MONEDA);
                        }else {
                          found = null;
                        }
                    }
                  })
        if (props.tableRow.row.value === this.state.segundo_grupo || (props.tableRow.row.value !== this.state.segundo_grupo && allMONEDAS.length>1))
        {
         return <Table.StubCell style={{ border: 'none' }}/>;
        }
       
        return (<TableSummaryRow.TotalCell {...props} />);
       
       }
       
       const StubCellComponentTable = ({ colSpan,...props}) => {
        var allMONEDAS=[]
        var found = null;
        this.state.rows.forEach(
          function getCheck(item, index) {
            if(item.CHECK1){
              found = allMONEDAS.find(grupo => grupo === item.SIMBOLO_MONEDA);
              if (found == null){
                allMONEDAS.push(item.SIMBOLO_MONEDA);
              }else {
                found = null;
              }
            }
          })

         if (props.tableRow.type.toString() === "Symbol(groupSummary)" && (props.tableRow.row.value === this.state.segundo_grupo || (props.tableRow.row.value !== this.state.segundo_grupo && allMONEDAS.length>1))) //&& props.tableColumn.type.toString() === "Symbol(group)"
         {
           return  (<Table.StubCell colSpan={colSpan} style={{ border: 'none' }} {...props} />); 
         }
         return (<Table.StubCell colSpan={props.tableColumn.key === "Symbol(flex)" ? 2 : colSpan} {...props} />);
       }
        this.TotalGroupCellComponent=TotalGroupCellComponent;
        this.StubCellComponentTable=StubCellComponentTable;
        this.VirtualTable_cellComponent = VirtualTable_cellComponent;
        this.VirtualTable_cellComponent_niveles=VirtualTable_cellComponent_niveles;
        this.trow = trow(Table.Row);
        this.trow_niveles = trow_niveles(Table.Row);
    }; //FIN CONSTRUCTORS

onEntering=()=>{
    this.consulta_suficiencia_especial()
}

aceptar_suficiencia=()=>{

    this.setState({ openBackDrop: true }, ()=>{
      let cuenta_alumno = this.state.valueAutoCompleteAdd!==null? this.state.valueAutoCompleteAdd.CUENTA_ALUMNO:'0'
        try{
        new Request
        .post(`${ip}/suficiencia/ID_suficiencia`)
        .set({'authorization': 'Bearer ' + Auth.getToken() })
        .set('Content-Type', 'application/json')
        .send({cuenta_alumno: Auth.getProfile().plataforma===2?Auth.getProfile().user:cuenta_alumno, ID_FACTURA: this.state.selection[0].ID_FACTURA, ID_CURSO_HIJO: this.state.selection[0].ID_CURSO_HIJO,ID_CURSO_PADRE: this.state.selection[0].ID_CURSO_PADRE
          , ID_DETALLE_PLAN: this.state.selection[0].ID_DETALLE_PLAN, TIPO: 1,ESPECIAL:0,ID_SUFICIENCIA: null,USUARIO: Auth.getProfile().user })
        .retry(0)
        .timeout({ response: 15000, deadline: 60000, }) 
        .end((err, res) => {
          if (err) { 
            if (err.toString().substr(0,16) === 'Error: Forbidden')
            { 
              window.location.reload();
              return;  
            }       
            this.setState({ openBackDrop: false }, ()=> { 
              funciones.showToast('e', 'Error de conexión'); 
            });
          }
    
          const rows = JSON.parse(res.text);
          if (rows.length > 0) 
          {    
            if (rows[0].RESP === 'OK')
            {   
                this.consulta_suficiencias()
                this.setState({openBackDrop: false, open_seleccion: false, selection: []}, ()=>{
                  funciones.showToast('s', 'Suficiencia ingresada correctamente.'); 
                })
            }
            else{
                this.setState({ openBackDrop: false}, ()=>{
                  funciones.showToast('w', rows[0].RESP);
                });
            }
          }           
          });       
        }
        catch(ex){
          this.setState({ openBackDrop: false}, ()=>{
            funciones.showToast('e', 'Error de conexión');
          });
        }
      })
}

aceptar_suficiencia_niveles=()=>{
  
  this.setState({ openBackDrop: true }, ()=>{
    let cuenta_alumno = this.state.valueAutoCompleteAdd!==null? this.state.valueAutoCompleteAdd.CUENTA_ALUMNO:'0'
    try{
    new Request
    .post(`${ip}/suficiencia/ID_suficiencia`)
    .set({'authorization': 'Bearer ' + Auth.getToken() })
    .set('Content-Type', 'application/json')
    .send({cuenta_alumno: Auth.getProfile().plataforma===2?Auth.getProfile().user:cuenta_alumno, ID_FACTURA: this.state.selection_niveles[0].ID_FACTURA, ID_CURSO_HIJO: this.state.selection_niveles[0].ID_CURSO_HIJO,ID_CURSO_PADRE: this.state.selection_niveles[0].ID_CURSO_PADRE
      , ID_DETALLE_PLAN: this.state.selection_niveles[0].ID_DETALLE_PLAN, TIPO: 1,ESPECIAL:1,ID_SUFICIENCIA: this.state.selection[0].ID_SUFICIENCIA,USUARIO: Auth.getProfile().user })
    .retry(0)
    .timeout({ response: 15000, deadline: 60000, }) 
    .end((err, res) => {
      if (err) { 
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        { 
          window.location.reload();
          return;  
        }       
        this.setState({ openBackDrop: false }, ()=> { 
          funciones.showToast('e', 'Error de conexión'); 
        });
      }

      const rows = JSON.parse(res.text);
      if (rows.length > 0) 
      {    
        if (rows[0].RESP === 'OK')
        {   
            this.consulta_suficiencia_especial()
            this.setState({openBackDrop: false, open_seleccion_niveles: false, selection_niveles: []}, ()=>{
              funciones.showToast('s', 'Suficiencia ingresada correctamente.'); 
            })
        }
        else{
            this.setState({ openBackDrop: false}, ()=>{
              funciones.showToast('w', rows[0].RESP);
            });
        }
      }           
      });       
    }
    catch(ex){
      this.setState({ openBackDrop: false}, ()=>{
        funciones.showToast('e', 'Error de conexión');
      });
    }
  })
}

quitar_suficiencia_niveles=()=>{
  this.setState({ openBackDrop: true }, ()=>{
    let cuenta_alumno = this.state.valueAutoCompleteAdd!==null? this.state.valueAutoCompleteAdd.CUENTA_ALUMNO:'0'
    try{
    new Request
    .post(`${ip}/suficiencia/ID_suficiencia`)
    .set({'authorization': 'Bearer ' + Auth.getToken() })
    .set('Content-Type', 'application/json')
    .send({cuenta_alumno: Auth.getProfile().plataforma===2?Auth.getProfile().user:cuenta_alumno, ID_FACTURA: this.state.selection_niveles[0].ID_FACTURA, ID_CURSO_HIJO: this.state.selection_niveles[0].ID_CURSO_HIJO,ID_CURSO_PADRE: this.state.selection_niveles[0].ID_CURSO_PADRE
      , ID_DETALLE_PLAN: this.state.selection_niveles[0].ID_DETALLE_PLAN, TIPO: 2,ESPECIAL:1,ID_SUFICIENCIA: this.state.selection[0].ID_SUFICIENCIA,USUARIO: Auth.getProfile().user })
    .retry(0)
    .timeout({ response: 15000, deadline: 60000, }) 
    .end((err, res) => {
      if (err) { 
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        { 
          window.location.reload();
          return;  
        }       
        this.setState({ openBackDrop: false }, ()=> { 
          funciones.showToast('e', 'Error de conexión'); 
        });
      }

      const rows = JSON.parse(res.text);
      if (rows.length > 0) 
      {    
        if (rows[0].RESP === 'OK')
        {   
            this.consulta_suficiencia_especial()
            this.setState({openBackDrop: false, open_borrar_niveles: false, selection_niveles: []}, ()=>{
              funciones.showToast('s', 'Se eliminó satisfactoriamente.'); 
            })
        }
        else{
            this.setState({ openBackDrop: false}, ()=>{
              funciones.showToast('w', rows[0].RESP);
            });
        }
      }           
      });       
    }
    catch(ex){
      this.setState({ openBackDrop: false}, ()=>{
        funciones.showToast('e', 'Error de conexión');
      });
    }
  })
}

quitar_suficiencia=()=>{

  this.setState({ openBackDrop: true }, ()=>{
    let cuenta_alumno = this.state.valueAutoCompleteAdd!==null? this.state.valueAutoCompleteAdd.CUENTA_ALUMNO:'0'
      try{
      new Request
      .post(`${ip}/suficiencia/ID_suficiencia`)
      .set({'authorization': 'Bearer ' + Auth.getToken() })
      .set('Content-Type', 'application/json')
      .send({cuenta_alumno: Auth.getProfile().plataforma===2?Auth.getProfile().user:cuenta_alumno, ID_FACTURA: this.state.selection[0].ID_FACTURA, ID_CURSO_HIJO: this.state.selection[0].ID_CURSO_HIJO,ID_CURSO_PADRE: this.state.selection[0].ID_CURSO_PADRE
        , ID_DETALLE_PLAN: this.state.selection[0].ID_DETALLE_PLAN, TIPO: 2,ESPECIAL:0,ID_SUFICIENCIA: null,USUARIO: Auth.getProfile().user })
      .retry(0)
      .timeout({ response: 15000, deadline: 60000, }) 
      .end((err, res) => {
        if (err) { 
          if (err.toString().substr(0,16) === 'Error: Forbidden')
          { 
            window.location.reload();
            return;  
          }       
          this.setState({ openBackDrop: false }, ()=> { 
            funciones.showToast('e', 'Error de conexión'); 
          });
        }
  
        const rows = JSON.parse(res.text);
        if (rows.length > 0) 
        {    
            if (rows[0].RESP === 'OK')
           {   
              this.consulta_suficiencias()
              this.setState({openBackDrop: false,open_borrar: false,selection: []}, ()=>{
                funciones.showToast('s', 'Se eliminó satisfactoriamente.'); 
              })
            }
            else{
                this.setState({ openBackDrop: false}, ()=>{
                  funciones.showToast('w', rows[0].RESP);
                });
            }
        }           
        });       
      }
      catch(ex){
        this.setState({ openBackDrop: false}, ()=>{
          funciones.showToast('e', 'Error de conexión');
        });
      }
    })
}



componentDidMount()
{
        let _this = this;
         _this.actualizarcircular(false)
      //  Auth.loggedIn().then( function(b){
          //  _this.setState({ isLoggin: b})
            if(Auth.getProfile().plataforma===1){
              _this.filtersClientes('-');
            }
            
            //if(b)
          this.setState({ isLoggin: Auth.getProfile().plataforma !== undefined ? true : false }, ()=>{
            Request.get(`${ip}/suficiencia/obtener_seleccion_suficiencia/${Auth.getProfile().user}`)
            .set({'authorization': 'Bearer ' + Auth.getToken() })
            .retry(10)
            .timeout({ response: 5000, deadline: 50000, }) 
            .end((err, res)=> {
             if (err) { 
                    if (err.toString().substr(0,16) === 'Error: Forbidden')
                    {
                      window.location.reload();
                      return;  
                    }
                    (async function() {
                      funciones.showToast('e', 'Error de conexión');
                    })();//FIN FUNCION ASYNC
                    return;
            }
            const tmp = JSON.parse(res.text);
            
            if(tmp.length>0){
                var allGroups=[]
                var grupo=''
                var found = null;
                tmp.forEach(
                  function getCheck(item, index) {
                    found = allGroups.find(grupo => grupo === item.GRUPO);
                    if(index===tmp.length-1)
                    grupo=item.GRUPO
                    if (found == null){
                       allGroups.push(item.GRUPO);
                    }else {
                      found = null;
                    }
                  })
                  _this.setState({ rows: tmp,expandedGroups: allGroups,segundo_grupo: grupo, heightTableMain: funciones.getHeightTableMain(movil_pequeño,_this).heightTable
                }); 
                }
                else
                {
                  _this.setState({rows: [], heightTableMain: funciones.getHeightTableMain(movil_pequeño,_this).heightTable})
                }
            
            _this.actualizarcircular(true)
        })
      })
}

consulta_suficiencia_especial=()=>{
  var _this=this

  this.setState({openBackDrop: true},()=>{
    let cuenta_alumno = this.state.valueAutoCompleteAdd!==null? this.state.valueAutoCompleteAdd.CUENTA_ALUMNO:'0'
  try{
    Request.get(`${ip}/suficiencia/obtener_suficiencia_especial/${Auth.getProfile().plataforma===2?Auth.getProfile().user:cuenta_alumno}/${this.state.selection[0].ID_DETALLE_PLAN}`)
    .set({'authorization': 'Bearer ' + Auth.getToken() })
    .retry(10)
    .timeout({ response: 5000, deadline: 50000, }) 
    .end((err, res)=> {
        if (err) { 
          if (err.toString().substr(0,16) === 'Error: Forbidden')
          {
            window.location.reload();
            return;  
          }
            (async function() {
              _this.setState({openBackDrop:false }); 
              funciones.showToast('e', 'Error de conexión');
          })();//FIN FUNCION ASYNC
          return;
        }
        const tmp = JSON.parse(res.text);
        if(tmp.length>0){
          _this.setState({ rows_niveles: tmp,openBackDrop:false }); 
        }
        else
        {
          _this.setState({rows_niveles: [],openBackDrop:false})
        }
    })
  }
  catch(ex){
    _this.setState({openBackDrop:false }); 
    funciones.showToast('e', 'Error de conexión');
  }
  })
}

consulta_suficiencias=()=>{
  this.actualizarcircular(false)
  let cuenta_alumno = this.state.valueAutoCompleteAdd!==null? this.state.valueAutoCompleteAdd.CUENTA_ALUMNO:'0'
  try{
    Request.get(`${ip}/suficiencia/obtener_seleccion_suficiencia/${Auth.getProfile().plataforma===1?cuenta_alumno:Auth.getProfile().user}`)
    .set({'authorization': 'Bearer ' + Auth.getToken() })
    .retry(10)
    .timeout({ response: 5000, deadline: 50000, }) 
    .end((err, res)=> {
        if (err) { 
          if (err.toString().substr(0,16) === 'Error: Forbidden')
          {
            window.location.reload();
            return;  
          }
            (async function() {
              funciones.showToast('e', 'Error de conexión');
          })();//FIN FUNCION ASYNC
          return;
        }
        const tmp = JSON.parse(res.text);
        if(tmp.length>0){
          var allGroups=[]
          var grupo=''
          var found = null;
          tmp.forEach(
            function getCheck(item, index) {
              found = allGroups.find(grupo => grupo === item.GRUPO);
              if(index===tmp.length-1)
              grupo=item.GRUPO
              if (found == null){
                 allGroups.push(item.GRUPO);
              }else {
                found = null;
              }
            })
            this.setState({ rows: tmp,filters:[], expandedGroups: allGroups,segundo_grupo: grupo, heightTableMain: funciones.getHeightTableMain(movil_pequeño,this).heightTable}); 
        }
        else
        {
          this.setState({rows: [], heightTableMain: funciones.getHeightTableMain(movil_pequeño,this).heightTable})
        }
              
      this.actualizarcircular(true)
    })
  }
  catch(ex){
    funciones.showToast('e', 'Error de conexión');
    this.actualizarcircular(true)
  }
}

cerrardialog_niveles =()=> event =>{
  this.setState({open_niveles: false,selection: [],selection_niveles:[],rows_niveles:[]},()=>{

  })
}

cerrardialog_selection =()=> event =>{
  this.setState({open_seleccion: false, open_borrar: false,selection: []},()=>{
  })
}
cerrardialog_selection_niveles =()=> event =>{
  this.setState({open_seleccion_niveles: false, open_borrar_niveles: false,selection_niveles: []},()=>{
  })
}

changeFilters = filters => this.setState({ filters });

changeExpandedGroups = expandedGroups =>
{
    this.setState({ expandedGroups });
};


filtersClientes = (value)=>{

  new Request
   .get(`${globales.ip}/Filtrar_estudiantes/${value}`)
   .set({'authorization': 'Bearer ' + Auth.getToken() })
   .retry(0)
   .timeout({ response: 20000, deadline: 30000, })
   .end((err, res) => {
          
      if (err) {
         if (err.toString().substr(0,16) === 'Error: Forbidden')
         {
           window.location.reload();
           return;
         }
       this.setState({ optionAutocompleteAdd: [], openAutoComplete: false, isLoadingClientes: false }, ()=>{
           funciones.showToast('e', 'No hay conexión');
       });
         return;
      }
        
      const rows = JSON.parse(res.text);
  
      if (rows.length > 0)
      {    
         this.setState({ optionAutocompleteAdd: rows, isLoadingClientes: false });
      }
      else
      {
         this.setState({ optionAutocompleteAdd: [], openAutoComplete: false, isLoadingClientes: false })
      }              
   });
 }
 

onBlurAutoCompleteAdd = ()=>{

  if (this.state.openAutoCompleteAdd)
  {
   this.setState({ openAutoCompleteAdd: false });    
  }

}


onChangeAutocompleteAdd = (event, value) => {

  this.setState({ valueAutoCompleteAdd: value, openAutoCompleteAdd: false }, ()=>{
    this.consulta_suficiencias()
  });
  
}
onChangeInput = (e, value)=>{ 

  if (e === null || e.target.value === undefined)
  {
    if (this.state.openAutoCompleteAdd){ 
       this.setState({ openAutoCompleteAdd: false });
    }
    return;
  }
  
  if ((e.target.value.toString().trim().length < 3 || (this.state.valueAutoCompleteAdd !== null && value === this.state.valueAutoCompleteAdd.CUENTA_ALUMNO + ' | ' + this.state.valueAutoCompleteAdd.NOMBRE_COMPLETO)) && this.state.openAutoCompleteAdd)
  {
    this.setState({ openAutoCompleteAdd: false });
  }
  else if (e.target.value.toString().trim().length >= 3  && !this.state.openAutoCompleteAdd)
  {
    this.setState({ openAutoCompleteAdd: true });
  }

}


/*                                          RENDER                          */
render() {
    const { classes } = this.props;

    const botones_seleccionar = [
        {icono: 'CheckCircle',    nombre: 'Aceptar'   ,escritura:true, onclick: this.aceptar_suficiencia
        ,  display: 'auto',color: 'green'},
        {icono: 'Close',  nombre: 'Cerrar' ,onclick: this.cerrardialog_selection(), display:'auto', color: 'red'},
    ]
    const botones_quitar = [
      {icono: 'Delete',    nombre: 'Aceptar'   ,escritura:true, onclick: this.quitar_suficiencia
      ,  display: 'auto',color: 'green'},
      {icono: 'Close',  nombre: 'Cerrar' ,onclick: this.cerrardialog_selection(), display:'auto', color: 'red'},
    ]
    const botones_seleccionar_niveles = [
      {icono: 'CheckCircle',    nombre: 'Aceptar'   ,escritura:true, onclick: this.aceptar_suficiencia_niveles
      ,  display: 'auto',color: 'green'},
      {icono: 'Close',  nombre: 'Cerrar' ,onclick: this.cerrardialog_selection_niveles(), display:'auto', color: 'red'},
    ]
    const botones_quitar_niveles = [
      {icono: 'Delete',    nombre: 'Aceptar'   ,escritura:true, onclick: this.quitar_suficiencia_niveles
      ,  display: 'auto',color: 'green'},
      {icono: 'Close',  nombre: 'Cerrar' ,onclick: this.cerrardialog_selection_niveles(), display:'auto', color: 'red'},
    ]
    const botones_niveles = [
      {icono: 'Close',  nombre: 'Cerrar' ,onclick: this.cerrardialog_niveles(), display:'auto', color: 'red'},
  ]

    if (this.state.isLoggin === true )
    {
        return (
            <React.Fragment>
            {Auth.getProfile().plataforma===1?
              <div align="center" style={{marginBottom: 10,marginTop: 10}}>
                  <Autocomplete
                    id="estudiante"
                    options={this.state.optionAutocompleteAdd}
                    getOptionLabel={(option) => option.CUENTA_ALUMNO + ' | ' + option.NOMBRE_COMPLETO}
                    style={{ width: !movil ? '500px' : '95%' }} 
                    renderInput={(params) => <TextField {...params} 
                          label="Estudiante"
                          variant="outlined"                                                              
                          onBlur={this.onBlurAutoCompleteAdd}                                                                                                                         
                          InputProps={{...params.InputProps,endAdornment: (
                                      <React.Fragment>
                                        {this.state.isLoadingClientes ? <CircularProgress color='secondary' size={25} /> : null}
                                        {params.InputProps.endAdornment}
                                      </React.Fragment>
                                      ),
                                      readOnly: this.state.isSaving
                                      }}
                                    />}
                          renderOption={(option) => (
                          <React.Fragment>                                     
                          <span style={{  minWidth: !movil ? '16%' : '25%' }}>{option.CUENTA_ALUMNO}</span>
                          {option.NOMBRE_COMPLETO}                                      
                          </React.Fragment>
                          )}
                          noOptionsText={'No hay resultados'}
                          loadingText={'Cargando...'}                                  
                          onChange={this.onChangeAutocompleteAdd}
                          open={this.state.openAutoCompleteAdd}
                          loading = {this.state.isLoadingClientes}
                          ListboxComponent={ListboxComponent}
                          disableListWrap
                          value={this.state.valueAutoCompleteAdd} 
                          autoHighlight
                          disableClearable={this.state.isSaving}
                          clearText = 'Borrar'
                          openText = ''
                          closeText = ''
                          classes= {{ popper: classes.popper }}
                          onInputChange={this.onChangeInput}                                                                            
                         />                 
              </div>
            :null
            }

            <Backdrop className={classes.backdrop}  open={this.state.openBackDrop}>
              <CircularProgress color="inherit" />
              <span style={{ marginTop: '10px' }}>{this.state.open_seleccion?'Guardando...':this.state.open_borrar?'Eliminando...':''}</span>
            </Backdrop>
            <Dialog open={this.state.open_niveles} fullWidth={true} maxWidth='md'
             classes = {{ paper: classes.Dialog}}
             //onEntering={this.onEntering}
             TransitionProps={{ onEntering: this.onEntering }}
            >
            <DialogTitle style={{background:colores.azul,textAlign:'center', marginBottom:20,padding:2, color: 'white'}}>
              {'Facturar Otros Niveles'}
            </DialogTitle>
            <DialogContent style={{marginBottom:20}}>
            <CustomTable
                Columns={columns_niveles}                                    
                Rows={this.state.rows_niveles}                                          
                TableColumnExtensions={tableColumnExtensions_niveles}
                DefaultHiddenColumnNames={defaultHiddenColumnNames_niveles}
                getRowId = {getRowId_niveles}
                Selection={this.state.selection_niveles}
                //ChangeSelection = {this.changeSelection}
                height={'300px'}
                //rowHeaderCellComponent={ColumnHeader_cellComponent(classes,this.handleInfoClick())}
                //ExpandedRowIds = {this.state.expandedRowIds}
                enabledFilterRows= {false}
                RowComponent={this.trow_niveles}
                standarPlugin = { <TableRowsIndexer/> }
                ChangeExpandedGroups = {this.changeExpandedGroups}  
                VirtualTable_cellComponent={this.VirtualTable_cellComponent_niveles}
                showSelectionColumn={false}
            />
            </DialogContent>
            <BarraBotones align='center' botones={botones_niveles} l={this.l} e={this.e} i={this.i}/>
            </Dialog>
            <Dialog open={this.state.open_seleccion||this.state.open_borrar} fullWidth={true} maxWidth='xs'
             classes = {{ paper: classes.Dialog}}
            >
            <DialogTitle style={{background:colores.azul,textAlign:'center', marginBottom:20,padding:2, color: 'white'}}>
              {'Confirmación'}
            </DialogTitle>
            <DialogContent style={{marginBottom:20}}>
            <Typography align='center' >
              {(this.state.open_seleccion?'¿Desea agregar la factura pendiente de suficiencia para la clase  ':this.state.open_borrar?'¿Desea quitar la factura de la suficiencia por la clase ':'')+(this.state.selection.length>0?this.state.selection[0].DESCRIPCION_CURSO:'')+'?'
              }
            </Typography>
            </DialogContent>
            <BarraBotones align='center' botones={this.state.open_seleccion?botones_seleccionar:this.state.open_borrar?botones_quitar:[]} l={this.l} e={this.e} i={this.i}/>
            </Dialog>
            <Dialog open={this.state.open_seleccion_niveles||this.state.open_borrar_niveles} fullWidth={true} maxWidth='xs'
             classes = {{ paper: classes.Dialog}}
            >
            <DialogTitle style={{background:colores.azul,textAlign:'center', marginBottom:20,padding:2, color: 'white'}}>
              {'Confirmación'}
            </DialogTitle>
            <DialogContent style={{marginBottom:20}}>
            <Typography align='center' >
              {(this.state.open_seleccion_niveles?'¿Seleccionó ':this.state.open_borrar_niveles?'¿Desea quitar ':'')+(this.state.selection_niveles.length>0?this.state.selection_niveles[0].DESCRIPCION_CURSO:'')+'?'
              }
            </Typography>
            </DialogContent>
            <BarraBotones align='center' botones={this.state.open_seleccion_niveles?botones_seleccionar_niveles:this.state.open_borrar_niveles?botones_quitar_niveles:[]} l={this.l} e={this.e} i={this.i}/>
            </Dialog>
            <div ref={this.tablaRef} style={{background:'white',marginLeft:movil_pequeño?globales.tabla.marginleft_movil:globales.tabla.marginleft,marginRight:movil_pequeño?globales.tabla.marginright_movil:globales.tabla.marginright}}>
            <CustomTable
                Columns={columns}                                    
                Rows={this.state.rows}                                          
                TableColumnExtensions={tableColumnExtensions}
                DefaultHiddenColumnNames={defaultHiddenColumnNames}
                getRowId = {getRowId}
                Selection={this.state.selection}
               // ChangeSelection = {this.changeSelection}
                height={this.state.heightTableMain}
                Filters = {this.state.filters}
                onFiltersChange = {this.changeFilters}
                //rowHeaderCellComponent={ColumnHeader_cellComponent(classes,this.handleInfoClick())}
                //ExpandedRowIds = {this.state.expandedRowIds}
                enabledFilterRows= {this.state.enabledFilterRows}
                RowComponent={this.trow}
                standarPlugin = { <TableRowsIndexer/> }
                Grouping={grouping}
                ExpandedGroups = {this.state.expandedGroups} 
                ChangeExpandedGroups = {this.changeExpandedGroups}  
                //totalItems={totalSummaryItems}
                groupItems={groupSummaryItems}
                summaryRowMessages={{ count: 'Count', sum: 'Monto' }}
                VirtualTable_cellComponent={this.VirtualTable_cellComponent}
                showSelectionColumn={false}
                groupContentComponent={GroupCellContent}
                groupCellComponent={this.TotalGroupCellComponent}          
                stubCellComponentTable={this.StubCellComponentTable}
            />
            </div>
            </React.Fragment>
        ); /// finaliza return
    }
    else if (this.state.isLoggin === false)
    {
        Auth.logout()
        window.location.reload();
        return; 
    }


    return null;
} /// finaliza render
} /// finaliza class
)/// finaliza withStyles
